function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, RefObject, CSSProperties, ButtonHTMLAttributes, HtmlHTMLAttributes, MouseEventHandler } from 'react';
import cn from 'classnames';
import { Image } from '../Image';
import { Icon } from '../Icon';
require("./Avatar.css");
var styles = {
  "Root": "Avatar-module-Root_aqW"
};
export const AvatarVariants = {
  user: 'user',
  bot: 'bot'
};
export const AvatarTags = {
  div: 'div',
  button: 'button'
};
export const Avatar = ({
  src,
  alt,
  tag = AvatarTags.div,
  variant = AvatarVariants.user,
  onClick,
  style,
  className,
  innerRef,
  controlRef,
  ...props
}) => {
  const RootTag = tag;
  const rootProps = {
    ...(props || {})
  };
  if (tag === AvatarTags.button) {
    rootProps.type = 'button';
  }
  return /*#__PURE__*/React.createElement(RootTag, _extends({
    ref: innerRef || controlRef,
    className: cn(styles.Root, className),
    style: style,
    onClick: onClick
  }, rootProps), src ? /*#__PURE__*/React.createElement(Image, {
    src: src,
    alt: alt
  }) :
  /*#__PURE__*/
  // TODO иконка user не по дизу, изменить когда дорисуют
  React.createElement(Icon, {
    name: variant === AvatarVariants.user ? 'profile' : 'home',
    size: "m"
  }));
};
if (process.env.NODE_ENV !== 'production') {
  Avatar.displayName = 'Avatar';
}